import { fetchWithTokenRefresh } from "views_shared/app/javascript/api/withTokenRefresh";

const SUPABASE_URL = () => globalThis.Qwoted?.SUPABASE_API_EXTERNAL_URL;

// Fetch full details (incl. is_publishable) for previously-selected expert
// IDs from the admin_experts_lookup PostgREST view. Used by the picker on
// edit-mode mount.
export async function fetchSelectedDetails(ids) {
  if (!ids || ids.length === 0) return [];

  const idList = ids.map((id) => encodeURIComponent(id)).join(",");
  const url = `${SUPABASE_URL()}/rest/v1/admin_experts_lookup?id=in.(${idList})&select=*`;

  // fetchWithTokenRefresh transparently handles 401 → refresh → retry.
  const response = await fetchWithTokenRefresh(url, {
    headers: { "Content-Type": "application/json" },
  });

  if (!response.ok) throw new Error(`Lookup failed (${response.status})`);
  return response.json();
}

// Hit the Rails search endpoint (Admin::Api::SearchController) with a query
// + filters. `mode` is "semantic" (OpenAI embedding search; takes
// withinDistance) or "by_name" (DB name match; ignores withinDistance).
//
// Throws on non-OK responses. The thrown Error has `.retryAdvised` and
// `.status` set when the server returned a structured error body, so the
// picker UI can show the right affordance.
export async function searchExperts({ mode, query, withinDistance, loginRecency, limit = 20, signal }) {
  const params = new URLSearchParams({
    subject: "expert",
    mode,
    q: query,
    login_recency: loginRecency,
    limit: String(limit),
  });
  if (mode === "semantic") params.append("within_distance", String(withinDistance));

  const response = await fetchWithTokenRefresh(`/admin/api/search?${params.toString()}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    signal,
  });

  if (!response.ok) {
    let body = null;
    try {
      body = await response.json();
    } catch (_) {
      // Server returned a non-JSON error body (e.g. 5xx HTML page).
    }
    const message = body?.error || `Search failed (${response.status})`;
    const error = new Error(message);
    error.retryAdvised = Boolean(body?.retry_advised);
    error.status = response.status;
    throw error;
  }

  const json = await response.json();
  // Response envelope is { data: { expert: { rows: [...] } } } as of the
  // FINDERS refactor. The rows array is what the picker UI consumes.
  return json.data?.expert?.rows || [];
}
